export const registerSharedDependency = <T>(key: string, valueFn: () => T): T => {
  if (!Object.prototype.hasOwnProperty.call(window, key)) {
    Object.defineProperty(window, key, {
      value: valueFn(),
      writable: false,
      enumerable: false,
      configurable: true,
    })
  }
  // @ts-ignore WAIT MF
  return window[key] as T
}
